//#region types
import { TranslationKeys } from "translations";
import { CommonConstants } from "utils/constants";
import { NumberInputProps, TextInputProps } from "models/propTypes/wintFormPropsTypes";
import { ReceiptTodoManualPaymentSectionProps } from "models/propTypes/receiptPropTypes";
//#endregion
//#region components
import {
  ExpandableSection,
  ExpandableSectionSummary,
  NumberInput,
  TextInput,
  Toggle,
  VerticalFormField,
} from "components/common/wintForms";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const ReceiptTodoManualPaymentSection: React.FC<ReceiptTodoManualPaymentSectionProps> = ({
  connect,
  onChangeHandler,
  expandableStepProps,
}) => {
  const isManualPaymentConnect = connect("isManualPayment");

  const onManualPaymentChange = (value: boolean) => {
    isManualPaymentConnect.setValue(value);
    onChangeHandler?.(value);
  };

  return (
    <ExpandableSection
      summary={
        <ExpandableSectionSummary
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ReceiptPaymentInformation)}
        />
      }
      initiallyOpen
      {...expandableStepProps}
    >
      <VerticalFormField
        Component={Toggle}
        {...isManualPaymentConnect}
        onChangeHandler={onManualPaymentChange}
        label={TranslationKeys.Payments.ManualPayment}
        descriptionText={TranslationKeys.Receipt.ManualPaymentDescription}
        showMainLabel
      />
      <VerticalFormField<NumberInputProps>
        Component={NumberInput}
        {...connect("personNumber")}
        label={TranslationKeys.Settings.PersonNumber}
        allowLeadingZeros
        format={CommonConstants.PersonNumberMask}
      />
      <VerticalFormField<TextInputProps>
        Component={TextInput}
        {...connect("clearingNumber")}
        label={TranslationKeys.Settings.ClearingNumber}
        descriptionText={TranslationKeys.Settings.ClearingNumberDescription}
      />
      <VerticalFormField<TextInputProps>
        Component={TextInput}
        {...connect("bankAccount")}
        label={TranslationKeys.Settings.AccountNumber}
        descriptionText={TranslationKeys.Settings.AccountNumberDescription}
      />
    </ExpandableSection>
  );
};

export default ReceiptTodoManualPaymentSection;
